module.exports = __webpack_public_path__ + "static/img/lab-2.fca5c4ab.jpg";